import { Route } from '@angular/router';
import { AppRoutes } from './shared/constants/app-routes.constant';
import { AuthenticationGuard } from './shared/guards/authentication.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: AppRoutes['PROGRAMS'].fullPath,
    pathMatch: 'full',
  },
  {
    path: AppRoutes['LOGIN'].fullPath,
    loadComponent: () =>
      import('./pages/login/login.component').then((c) => c.LoginComponent),
  },
  {
    path: AppRoutes['RECOVERY_PASSWORD'].fullPath,
    loadComponent: () =>
      import('./pages/recovery-password/recovery-password.component').then(
        (c) => c.RecoveryPasswordComponent
      ),
  },
  {
    path: AppRoutes['SIGN_UP'].fullPath,
    loadComponent: () =>
      import('./pages/signup/signup.component').then((c) => c.SignupComponent),
  },
  {
    path: AppRoutes['PROGRAMS'].fullPath,
    canActivate: [AuthenticationGuard],
    loadComponent: () =>
      import('./pages/programs/programs.component').then(
        (c) => c.ProgramsComponent
      ),
  },
  {
    path: AppRoutes['PROGRAM'].fullPath,
    canActivate: [AuthenticationGuard],
    loadComponent: () =>
      import('./pages/program/program.component').then(
        (c) => c.ProgramComponent
      ),
  },
  {
    path: AppRoutes['PROGRAM_ANSWERED'].fullPath,
    canActivate: [AuthenticationGuard],
    loadComponent: () =>
      import('./pages/program-answered/program-answered.component').then(
        (c) => c.ProgramAnsweredComponent
      ),
  },
  {
    path: AppRoutes['PROFILE'].fullPath,
    canActivate: [AuthenticationGuard],
    loadComponent: () =>
      import('./pages/profile/profile.component').then(
        (c) => c.ProfileComponent
      ),
  },
  {
    path: '**',
    redirectTo: AppRoutes['PROGRAMS'].fullPath,
  },
];
